import { authorizationSagas } from 'modules/Authorization/redux';
import { contactsSagas } from 'modules/Contacts/redux';
import { messagesSagas } from 'modules/Messages/redux';
import { newTaxesSagas } from 'modules/NewTaxes/redux';
import { paymentSagas } from 'modules/Payment/redux';
import { profileSagas } from 'modules/Profile/redux';
import { userIncomesSagas } from 'modules/UserIncomes/redux';
import { propertyObjectsSagas } from 'modules/PropertyObjects/redux';
import { tapsSagas } from 'modules/Taps/redux';
import { appSagas } from 'modules/App/redux';
import { checksSaga } from 'modules/Checks';
import configSaga from 'modules/ConfigWrapper/redux/saga';
import appIsReadyCheckSaga from './modules/AppIsReadyCheckWrapper/redux/saga';
import notificationsSaga from 'modules/Notifications/sagas';
import { declarationsSagas } from 'modules/Declarations/sagas';
import debounceActionsMiddleware from './debounceActionsMiddleware';

import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { all, fork } from 'redux-saga/effects';

import { enhancer as routerEnhancer, middleware as routerMiddleware } from './router';

import { makeRootReducer } from 'reducers';
import { initStore } from 'configureStore';

const isProd = process.env.NODE_ENV === 'production';
const debouncedActions = ['@@redux-form/REGISTER_FIELD', '@@redux-form/UNREGISTER_FIELD'];
const debounceWait = 100;

function configureStore() {
  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [
    debounceActionsMiddleware(debouncedActions, debounceWait),
    sagaMiddleware,
    routerMiddleware,
  ];

  let composeEnhancers = compose;

  if (!isProd) {
    // add support for Redux dev tools
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  }

  const store = createStore(
    makeRootReducer,
    undefined,
    composeEnhancers(routerEnhancer, applyMiddleware(...middlewares)),
  );

  const rootSaga = function* () {
    yield all(
      [
        appSagas,
        authorizationSagas,
        checksSaga,
        configSaga,
        appIsReadyCheckSaga,
        contactsSagas,
        messagesSagas,
        newTaxesSagas,
        paymentSagas,
        profileSagas,
        propertyObjectsSagas,
        tapsSagas,
        userIncomesSagas,
        notificationsSaga,
        declarationsSagas,
      ].map(fork),
    );
  };

  sagaMiddleware.run(rootSaga);

  return store;
}

initStore(configureStore());
